import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import CryptoJS from "crypto-js"; // ✅ Import CryptoJS

const ExcelToJSGenerator = () => {
  const secretKey = "myStrongSecretKey123"; // 🔐 Change this to a secure key

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (evt) => {
      const data = new Uint8Array(evt.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(sheet);

      const jsSnippets = jsonData.map((row) => {
        return `
        
setTimeout(() => {
  const idNumberInput = document.getElementById("idNumber");
  const idNumber = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  idNumber.call(idNumberInput, "${row.AdharNumber}");
  idNumberInput.dispatchEvent(new Event('input', { bubbles: true }));

  const nameInput = document.getElementById("sevakName");
  const nameSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  nameSetter.call(nameInput, "${row.Name}");
  nameInput.dispatchEvent(new Event('input', { bubbles: true }));


  const surNameInput = document.getElementById("surName");
  const surNameSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  surNameSetter.call(surNameInput, "${row.Surname}");
  surNameInput.dispatchEvent(new Event('input', { bubbles: true }));

  const fatherOrSpouseNameInput = document.getElementById("fatherOrSpouseName");
  const fatherOrSpouseNameSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  fatherOrSpouseNameSetter.call(fatherOrSpouseNameInput, "${row.FatherSpouce}");
  fatherOrSpouseNameInput.dispatchEvent(new Event('input', { bubbles: true }));


  const dobInput = document.getElementById("dob");
  const dobSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  dobSetter.call(dobInput, "${row.DOB}");
  dobInput.dispatchEvent(new Event('input', { bubbles: true }));

  const mobileNoInput = document.getElementById("mobileNo");
  const mobileNoSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  mobileNoSetter.call(mobileNoInput, "${row.Mobile}");
  mobileNoInput.dispatchEvent(new Event('input', { bubbles: true }));


  const emailInput = document.getElementById("email");
  const emailSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  emailSetter.call(emailInput, "${row.Email}");
  emailInput.dispatchEvent(new Event('input', { bubbles: true }));

  const genderInput = document.getElementById("gender");
  const genderSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  genderSetter.call(genderInput, "${row.Gender}");
  genderInput.dispatchEvent(new Event('input', { bubbles: true }));
  
  const professionInput = document.getElementById("profession");
  const professionSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  professionSetter.call(professionInput, "${row.Profession}");
  professionInput.dispatchEvent(new Event('input', { bubbles: true }));

  const countryInput = document.getElementById("country");
  const countrySetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  countrySetter.call(countryInput, "${row.Country}");
  countryInput.dispatchEvent(new Event('input', { bubbles: true }));

  const stateInput = document.getElementById("state");
  const stateSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  stateSetter.call(stateInput, "${row.State}");
  stateInput.dispatchEvent(new Event('input', { bubbles: true }));

  const districtInput = document.getElementById("district");
  const districtSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  districtSetter.call(districtInput, "${row.District}");
  districtInput.dispatchEvent(new Event('input', { bubbles: true }));

  const cityInput = document.getElementById("city");
  const citySetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  citySetter.call(cityInput, "${row.City}");
  cityInput.dispatchEvent(new Event('input', { bubbles: true }));

  const streetInput = document.getElementById("street");
  const streetSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  streetSetter.call(streetInput, "${row.Street}");
  streetInput.dispatchEvent(new Event('input', { bubbles: true }));

  const doorNoInput = document.getElementById("doorNo");
  const doorNoSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  doorNoSetter.call(doorNoInput, "${row.DoorNo}");
  doorNoInput.dispatchEvent(new Event('input', { bubbles: true }));

  const pincodeInput = document.getElementById("pincode");
  const pincodeSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  pincodeSetter.call(pincodeInput, "${row.Pincode}");
  pincodeInput.dispatchEvent(new Event('input', { bubbles: true }));

  const nearestTtdTempleInput = document.getElementById("nearestTtdTemple");
  const nearestTtdTempleInputSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  nearestTtdTempleInputSetter.call(nearestTtdTempleInput, "${row.NearestTtdTemple}");
  nearestTtdTempleInput.dispatchEvent(new Event('input', { bubbles: true }));

}, 500);
        `.trim();
      });

      // 🔒 Encrypt the JS string
      const fullText = jsSnippets.join("\n\n");
      const encrypted = CryptoJS.AES.encrypt(fullText, secretKey).toString();

      const blob = new Blob([encrypted], {
        type: "text/plain;charset=utf-8",
      });

      saveAs(blob, "ttd_members_encrypted.txt");
    };

    reader.readAsArrayBuffer(file);
  };

  return (
    <div className="container mt-4 d-flex flex-column align-items-center">
      <h3>Upload Excel File</h3>
      <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} />
    </div>
  );
};

export default ExcelToJSGenerator;
